import { NgModule } from "@angular/core";
import { SharedComponentsModule, SharedModule } from "app/shared";
import { UploaderModule } from "app/modules/upload/uploader/uploader.module";
import { ThumbsnailContainerComponent } from "./thumbsnail-container.component";
import { ThumbsnailContainerResolver } from "./thumbsnail-container.resolver";

@NgModule({
    imports: [SharedModule, SharedComponentsModule, UploaderModule],
    declarations: [ThumbsnailContainerComponent],
    providers: [ThumbsnailContainerResolver],
})
export class ThumbsnailContainerModule { }